import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { withRouter } from 'react-router-dom';
import useOnEsc from 'hooks/useOnEsc';
import useTrapFocus from 'hooks/useTrapFocus';
import useRandomId from 'hooks/useRandomId';
import useFocusOnOpen from 'hooks/useFocusOnOpen';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import getOrCreateElementById from 'commons/getOrCreateElementById';
import MobileModal from 'components/consumer/MobileModal';
import BodyScrollLock from 'components/consumer/BodyScrollLock';
import IconSimpleArrowLeft from 'components/icons/iconSimpleArrowLeft';
import IconClose from 'components/icons/iconClose';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
const fullScreenModalRootElement = getOrCreateElementById('FullScreenModal-root');
const FullScreenModal = t0 => {
  const $ = _c(99);
  const {
    children,
    closeAlign: t1,
    closeIcon,
    enableHashHistory: t2,
    className: t3,
    headerCenter,
    headerLeft,
    headerRight,
    hideBack,
    history,
    location: t4,
    isOpen: t5,
    mobileContent,
    mobileContentUnderHeader: t6,
    mobileHeaderCenter,
    mobileHeaderNoPointerEvents: t7,
    mobileHeaderRight,
    mobileHideHeader: t8,
    mobileIsFullHeight: t9,
    mobileNoPadding: t10,
    mobileContentNoPadding: t11,
    mobileNoStickyFooterPadding: t12,
    mobileScrollingHeader,
    mobileStickyFooter,
    mobileVariant,
    modalPath: t13,
    onBack,
    onClose,
    stickyFooter,
    title,
    withUnderLay: t14
  } = t0;
  const closeAlign = t1 === undefined ? "left" : t1;
  const enableHashHistory = t2 === undefined ? true : t2;
  const className = t3 === undefined ? "" : t3;
  let t15;
  if ($[0] !== t4) {
    t15 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t15;
  } else {
    t15 = $[1];
  }
  const location = t15;
  const isOpen = t5 === undefined ? false : t5;
  const mobileContentUnderHeader = t6 === undefined ? null : t6;
  const mobileHeaderNoPointerEvents = t7 === undefined ? false : t7;
  const mobileHideHeader = t8 === undefined ? false : t8;
  const mobileIsFullHeight = t9 === undefined ? true : t9;
  const mobileNoPadding = t10 === undefined ? false : t10;
  const mobileContentNoPadding = t11 === undefined ? false : t11;
  const mobileNoStickyFooterPadding = t12 === undefined ? false : t12;
  const modalPath = t13 === undefined ? "modal" : t13;
  const withUnderLay = t14 === undefined ? false : t14;
  const {
    isMobile
  } = useScreen();
  const modalRef = useFocusOnOpen(isOpen);
  const modalTitleId = useRandomId("FullScreenModal-title");
  useTrapFocus(isOpen && !isMobile, modalRef);
  const [isHistoryPushed, setIsHistoryPushed] = useState(false);
  let t16;
  if ($[2] !== location.state) {
    t16 = JSON.stringify(location.state);
    $[2] = location.state;
    $[3] = t16;
  } else {
    t16 = $[3];
  }
  const locationStateString = t16;
  let t17;
  let t18;
  if ($[4] !== enableHashHistory || $[5] !== history || $[6] !== isHistoryPushed || $[7] !== isMobile || $[8] !== isOpen || $[9] !== location.search || $[10] !== locationStateString || $[11] !== modalPath) {
    t17 = () => {
      if (!isMobile && enableHashHistory && history && !isHistoryPushed && isOpen) {
        const locationState = JSON.parse(locationStateString || "{}");
        history.push(`${location.search || ""}#${modalPath}`, locationState);
        setIsHistoryPushed(true);
      }
    };
    t18 = [isMobile, isOpen, enableHashHistory, history, isHistoryPushed, modalPath, locationStateString, location.search];
    $[4] = enableHashHistory;
    $[5] = history;
    $[6] = isHistoryPushed;
    $[7] = isMobile;
    $[8] = isOpen;
    $[9] = location.search;
    $[10] = locationStateString;
    $[11] = modalPath;
    $[12] = t17;
    $[13] = t18;
  } else {
    t17 = $[12];
    t18 = $[13];
  }
  useEffect(t17, t18);
  let t19;
  let t20;
  if ($[14] !== enableHashHistory || $[15] !== history || $[16] !== isHistoryPushed || $[17] !== isMobile || $[18] !== onClose) {
    t19 = () => {
      if (!isMobile && enableHashHistory && history && isHistoryPushed) {
        const unlisten = history.listen(() => {
          onClose();
        });
        return unlisten;
      }
    };
    t20 = [isMobile, enableHashHistory, history, isHistoryPushed, onClose];
    $[14] = enableHashHistory;
    $[15] = history;
    $[16] = isHistoryPushed;
    $[17] = isMobile;
    $[18] = onClose;
    $[19] = t19;
    $[20] = t20;
  } else {
    t19 = $[19];
    t20 = $[20];
  }
  useEffect(t19, t20);
  let t21;
  let t22;
  if ($[21] !== isOpen) {
    t21 = () => {
      if (!isOpen) {
        setIsHistoryPushed(false);
      }
    };
    t22 = [isOpen];
    $[21] = isOpen;
    $[22] = t21;
    $[23] = t22;
  } else {
    t21 = $[22];
    t22 = $[23];
  }
  useEffect(t21, t22);
  let t23;
  if ($[24] !== enableHashHistory || $[25] !== history || $[26] !== isHistoryPushed || $[27] !== isMobile || $[28] !== onClose) {
    t23 = () => {
      if (!isMobile && enableHashHistory && history && isHistoryPushed) {
        history.goBack();
      }
      onClose();
    };
    $[24] = enableHashHistory;
    $[25] = history;
    $[26] = isHistoryPushed;
    $[27] = isMobile;
    $[28] = onClose;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  const onCloseClick = t23;
  let t24;
  if ($[30] !== onCloseClick || $[31] !== withUnderLay) {
    t24 = event => {
      if (!withUnderLay || typeof event?.target?.className?.includes !== "function") {
        return;
      }
      if (event.target.className.includes("__with-underlay")) {
        onCloseClick();
      }
    };
    $[30] = onCloseClick;
    $[31] = withUnderLay;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  const checkUnderLayClick = t24;
  useOnEsc(isOpen, onCloseClick);
  if (!isOpen) {
    return null;
  }
  if (isMobile) {
    const t25 = mobileContentUnderHeader || mobileNoPadding;
    const t26 = mobileStickyFooter || stickyFooter;
    const t27 = mobileContent || children;
    let t28;
    if ($[33] !== className || $[34] !== closeIcon || $[35] !== enableHashHistory || $[36] !== isOpen || $[37] !== mobileContentNoPadding || $[38] !== mobileContentUnderHeader || $[39] !== mobileHeaderCenter || $[40] !== mobileHeaderNoPointerEvents || $[41] !== mobileHeaderRight || $[42] !== mobileHideHeader || $[43] !== mobileIsFullHeight || $[44] !== mobileNoStickyFooterPadding || $[45] !== mobileScrollingHeader || $[46] !== mobileVariant || $[47] !== modalPath || $[48] !== onCloseClick || $[49] !== t25 || $[50] !== t26 || $[51] !== t27 || $[52] !== title) {
      t28 = <MobileModal className={className} closeIcon={closeIcon} contentNoPadding={mobileContentNoPadding} contentUnderHeader={mobileContentUnderHeader} enableHashHistory={enableHashHistory} headerCenter={mobileHeaderCenter} headerNoPointerEvents={mobileHeaderNoPointerEvents} headerRight={mobileHeaderRight} hideHeader={mobileHideHeader} isFullHeight={mobileIsFullHeight} isOpen={isOpen} modalPath={modalPath} noPadding={t25} noStickyFooterPadding={mobileNoStickyFooterPadding} onClose={onCloseClick} scrollingHeader={mobileScrollingHeader} stickyFooter={t26} title={title} variant={mobileVariant}>{t27}</MobileModal>;
      $[33] = className;
      $[34] = closeIcon;
      $[35] = enableHashHistory;
      $[36] = isOpen;
      $[37] = mobileContentNoPadding;
      $[38] = mobileContentUnderHeader;
      $[39] = mobileHeaderCenter;
      $[40] = mobileHeaderNoPointerEvents;
      $[41] = mobileHeaderRight;
      $[42] = mobileHideHeader;
      $[43] = mobileIsFullHeight;
      $[44] = mobileNoStickyFooterPadding;
      $[45] = mobileScrollingHeader;
      $[46] = mobileVariant;
      $[47] = modalPath;
      $[48] = onCloseClick;
      $[49] = t25;
      $[50] = t26;
      $[51] = t27;
      $[52] = title;
      $[53] = t28;
    } else {
      t28 = $[53];
    }
    return t28;
  }
  const t25 = `${withUnderLay ? " h-screen left-0 fixed top-0 w-screen bg-[rgba(0,0,0,.6)]" : ""}`;
  const t26 = `bg-white flex flex-col z-[2000] h-screen left-0 fixed top-0 w-screen ${className}`;
  let t27;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <VisuallyHidden>Modal dialog content starts</VisuallyHidden>;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== closeAlign || $[56] !== onCloseClick) {
    t28 = closeAlign === "left" && <button type="button" className="bg-transparent rounded-[3px] border-2 border-solid border-transparent cursor-pointer h-[49px] left-2 px-[7px] py-[13px] absolute top-2 w-[34px] z-[7]" onClick={onCloseClick}><IconSimpleArrowLeft className="h-[49px] w-[30px] px-[7px] py-[13px] absolute z-[6] top-0 left-0 [&_path]:stroke-[#424242]" /></button>;
    $[55] = closeAlign;
    $[56] = onCloseClick;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== hideBack || $[59] !== onBack) {
    t29 = !!onBack && !hideBack && <button type="button" className="bg-transparent rounded-[3px] border-2 border-solid border-transparent cursor-pointer h-[49px] left-2 px-[7px] py-[13px] absolute top-2 w-[34px] z-[7]" onClick={onBack}><IconSimpleArrowLeft className="h-[49px] w-[30px] px-[7px] py-[13px] absolute z-[6] top-0 left-0 [&_path]:stroke-[#424242]" /></button>;
    $[58] = hideBack;
    $[59] = onBack;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== headerLeft) {
    t30 = <div className="z-[1]">{headerLeft}</div>;
    $[61] = headerLeft;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== headerCenter) {
    t31 = <div className="h-full left-0 px-14 py-4 absolute right-0 text-center top-0 z-0 flex flex-col items-center justify-center">{headerCenter}</div>;
    $[63] = headerCenter;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== headerRight) {
    t32 = <div className="z-[1]">{headerRight}</div>;
    $[65] = headerRight;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== t30 || $[68] !== t31 || $[69] !== t32) {
    t33 = <div className="items-center flex justify-between pl-[30px] w-full">{t30}{t31}{t32}</div>;
    $[67] = t30;
    $[68] = t31;
    $[69] = t32;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== closeAlign || $[72] !== onCloseClick) {
    t34 = closeAlign === "right" && <button type="button" className="bg-transparent rounded-[3px] border-2 border-solid border-transparent cursor-pointer h-[49px] left-2 px-[7px] py-[13px] absolute top-2 w-[34px] z-[7]" onClick={onCloseClick}><IconClose className="h-[49px] w-[30px] px-[7px] py-[13px] absolute z-[6] top-0 right-0 [&_path]:fill-gray-light6 [&:hover_path]:fill-gray" /></button>;
    $[71] = closeAlign;
    $[72] = onCloseClick;
    $[73] = t34;
  } else {
    t34 = $[73];
  }
  let t35;
  if ($[74] !== t28 || $[75] !== t29 || $[76] !== t33 || $[77] !== t34) {
    t35 = <div className="bg-white relative [border-bottom:1px_solid_#f1f1f1] flex h-[65px] p-4"><div className="items-center flex flex-1 flex-row z-[1]">{t28}{t29}{t33}{t34}</div></div>;
    $[74] = t28;
    $[75] = t29;
    $[76] = t33;
    $[77] = t34;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] !== modalTitleId || $[80] !== title) {
    t36 = title && <div className="text-xl font-bold text-gray pt-0 px-0 pb-4" id={modalTitleId}>{title}</div>;
    $[79] = modalTitleId;
    $[80] = title;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  let t37;
  if ($[82] !== children || $[83] !== t36) {
    t37 = <div className="bg-white relative flex-1 overflow-auto" id="FullScreen-content">{t36}{children}</div>;
    $[82] = children;
    $[83] = t36;
    $[84] = t37;
  } else {
    t37 = $[84];
  }
  let t38;
  if ($[85] !== stickyFooter) {
    t38 = <div className="FullScreenModal__sticky-footer">{stickyFooter}</div>;
    $[85] = stickyFooter;
    $[86] = t38;
  } else {
    t38 = $[86];
  }
  let t39;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <VisuallyHidden>Modal dialog content ends</VisuallyHidden>;
    $[87] = t39;
  } else {
    t39 = $[87];
  }
  let t40;
  if ($[88] !== t26 || $[89] !== t35 || $[90] !== t37 || $[91] !== t38) {
    t40 = <BodyScrollLock className={t26}>{t27}{t35}{t37}{t38}{t39}</BodyScrollLock>;
    $[88] = t26;
    $[89] = t35;
    $[90] = t37;
    $[91] = t38;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] !== checkUnderLayClick || $[94] !== modalRef || $[95] !== modalTitleId || $[96] !== t25 || $[97] !== t40) {
    t41 = createPortal(<div ref={modalRef} role="dialog" aria-labelledby={modalTitleId} className={t25} onClick={checkUnderLayClick}>{t40}</div>, fullScreenModalRootElement);
    $[93] = checkUnderLayClick;
    $[94] = modalRef;
    $[95] = modalTitleId;
    $[96] = t25;
    $[97] = t40;
    $[98] = t41;
  } else {
    t41 = $[98];
  }
  return t41;
};
FullScreenModal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeAlign: PropTypes.oneOf(['left', 'right']),
  closeIcon: PropTypes.node,
  enableHashHistory: PropTypes.bool,
  headerCenter: PropTypes.node,
  headerLeft: PropTypes.node,
  headerRight: PropTypes.node,
  hideBack: PropTypes.bool,
  history: PropTypes.shape({
    action: PropTypes.string,
    goBack: PropTypes.func,
    listen: PropTypes.func,
    push: PropTypes.func
  }),
  isOpen: PropTypes.bool,
  location: PropTypes.object,
  mobileContent: PropTypes.node,
  mobileContentUnderHeader: PropTypes.bool,
  mobileHeaderCenter: PropTypes.node,
  mobileHeaderNoPointerEvents: PropTypes.bool,
  mobileHeaderRight: PropTypes.node,
  mobileHideHeader: PropTypes.bool,
  mobileIsFullHeight: PropTypes.bool,
  mobileNoPadding: PropTypes.bool,
  mobileContentNoPadding: PropTypes.bool,
  mobileNoStickyFooterPadding: PropTypes.bool,
  mobileScrollingHeader: PropTypes.node,
  mobileStickyFooter: PropTypes.node,
  mobileVariant: PropTypes.string,
  modalPath: PropTypes.string,
  onBack: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  stickyFooter: PropTypes.node,
  title: PropTypes.string,
  withUnderLay: PropTypes.bool
};
export default withBrowserOnly(withRouter(FullScreenModal));